import uuid from 'react-uuid';
import './App.css';
import Header from './components/Header'
import EligibilityQuestioner from './features/eligibilityQuesioner/EligibilityQuestionerComponent'
import EligibilityResults from './features/eligibilityResults/EligibilityResultsComponent'
import { useState, useEffect, useCallback } from "react"
import { Route, Routes } from "react-router"
import { useNavigate, useLocation } from 'react-router-dom';
import Landing from './features/landing/LandingComponent'
import SignUp from './features/signUp/SignUpComponent'
import ResetPassword from './features/resetPassword/ResetPasswordComponent'
import ForgotPassword from './features/forgotPassword/ForgotPasswordComponent'
import ChangePassword from './features/changePassword/ChangePasswordComponent'
import { useAppSelector, useAppDispatch } from './app/hooks'
import FundOverview from './features/fundOverview/FundOverviewComponent';
import Fund from './features/fundOverview/Fund'
import SelfRating from './features/fundOverview/subsections/selfRating/SelfRating'
import Declaration from './features/fundOverview/subsections/declaration/Declaration'
import Preview from './features/fundOverview/subsections/preview/Preview'
import Home from './features/home/HomeComponent'
import Admin from './features/admin/AdminComponent'
import ProfileComponent from './features/profile/ProfileComponent'
import { ProfileNew } from './features/fundOverview/subsections/profile-new/ProfileNew';
import Workflow from './components/Workflow'
import DetailedApplication2A from './features/DetailedApplicationComponent/subsections/2A/detailedApplication2A';
import DetailedApplication2B from './features/DetailedApplicationComponent/subsections/2B/detailedApplication2B';
import DetailedApplication2C from './features/DetailedApplicationComponent/subsections/2C/detailedApplication2C';
import DetailedApplication2D from './features/DetailedApplicationComponent/subsections/2D/detailedApplication2D';
import DetailedApplication2E from './features/DetailedApplicationComponent/subsections/2E/detailedApplication2E';
import DetailedApplication2F from './features/DetailedApplicationComponent/subsections/2F/detailedApplication2F';
import DetailedApplication2G from './features/DetailedApplicationComponent/subsections/2G/detailedApplication2G';
import DetailedApplication2H from './features/DetailedApplicationComponent/subsections/2H/detailedApplication2H';
import DetailedApplication2I from './features/DetailedApplicationComponent/subsections/2I/detailedApplication2I';
import DetailedApplication2J from './features/DetailedApplicationComponent/subsections/2J/detailedApplication2J';
import DetailedApplication2K from './features/DetailedApplicationComponent/subsections/2K/detailedApplication2K';
import InvestmentThemeOfFund from './features/DetailedApplicationComponent/InvestmentThemeOfFund/investmentThemeOfFund';
import EngagementAndRole from './features/DetailedApplicationComponent/EngagementAndRole/engagementAndRole';
import CarryDistribution from './features/DetailedApplicationComponent/CarryDistribution/carryDistribution'
import DetailedApplicationComponent from './features/DetailedApplicationComponent/DetailedApplicationComponent';
import { SidbiReference } from './features/detailedApplication/sidbiReference/SidbiReference';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { UserAdminRoute } from './components/auth/UserAdminRoute';
import { UserRoute } from './components/auth/UserRoute';
import { CheckAuth } from '../src/app/api';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { refreshAccessToken } from './app/api';

const PUBLIC_AUTH_FLOW_PATHS = new Set([
  '/setPassword',
  '/resetPassword',
  '/signUp',
  '/eligibilityQuestioner',
  '/eligibilityResults',
]);

/** Routes where an expired JWT must not trigger immediate redirect to login (e.g. email reset links). */
function isPublicAuthFlowPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '') || '/';
  return PUBLIC_AUTH_FLOW_PATHS.has(p);
}

// let initialState = {
//   shoppingList : 'test'
// }

// export const UserContext = createContext(initialState);



const getTabId = () => {
  let tabId = sessionStorage.getItem('app_tab_id');
  if (!tabId) {
    tabId = uuid();
    sessionStorage.setItem('app_tab_id', tabId);
  }
  return tabId;
};
const TAB_ID = getTabId();

// Cross-tab session enforcement: newest tab wins.
// If this tab is NOT already kicked out AND a token exists, claim the session.
// Tab A (original) will detect the active_tab_id change via the 'storage' event,
// flag itself as kicked out in its own sessionStorage, and reload to login.
const _kicked = sessionStorage.getItem('kicked_out_crosstab') === 'true';
if (!_kicked) {
  const _initToken = localStorage.getItem('token');
  if (_initToken) {
    localStorage.setItem('active_tab_id', TAB_ID);
  }
}

function App() {
  // const [user, setUser] = useState(null);
  // const [selfRatingLink, setSelfRatingLink] = useCookie('selfRatingLink', '0');

  // let { shoppingList } = useContext(UserContext);
  // console.log(shoppingList);
  const isKickedOut = sessionStorage.getItem('kicked_out_crosstab') === 'true';
  const userLogged = !!useAppSelector(state => state.auth.token) && !isKickedOut;
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.auth.token);
  const mfaPending = useAppSelector(state => state.auth.mfaPending);

  // When another tab claims the session (active_tab_id changes in localStorage),
  // this tab flags ITSELF as kicked out via sessionStorage (private to this tab only),
  // then reloads. localStorage is NOT touched so Tab B keeps its token.
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'active_tab_id' && e.newValue !== null && e.newValue !== TAB_ID) {
        sessionStorage.setItem('kicked_out_crosstab', 'true');
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const checkIsCorrectStateToUpdate = (data: any, keyObj: any) => {
    let tempVal = false
    let keys = Object.keys(keyObj);
    let checkData = (data && typeof (data[Object.keys(data)[0]]) === 'object') ? data[Object.keys(data)[0]] : data
    keys.forEach((key) => {

      if (key != 'id' && key != 'parentId' && checkData.hasOwnProperty(key)) {
        tempVal = true;
      }
    });
    return tempVal
  }
  const THEME = createTheme({
    typography: {
      "fontFamily": "'Poppins', sans-serif",
    },
    components: {
      MuiInputBase: {
        defaultProps: {
          inputProps: {
            autoComplete: 'off',
          },
        },
      },
    },
  });
  const navigate = useNavigate();
  const location = useLocation();

  const [showExpiryDialog, setShowExpiryDialog] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [sessionEndsAt, setSessionEndsAt] = useState<number | null>(null);
  const [secondsRemaining, setSecondsRemaining] = useState<number>(0);
  const [overallSessionSecondsRemaining, setOverallSessionSecondsRemaining] = useState<number>(0);

  const logoutToLogin = useCallback(() => {
    localStorage.clear();
    CheckAuth.setIsUnauthorized();
    setShowExpiryDialog(false);
    setSessionEndsAt(null);
    navigate('/login');
  }, [navigate]);

  const parseTokenExpiry = (token: string): number | null => {
    try {
      const payload = token.split('.')[1];
      if (!payload) {
        // Security: Removed detailed session debug logging
        console.debug('[session] token validation failed - payload missing');
        return null;
      }
      const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
      const paddedPayload = normalizedPayload.padEnd(
        normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
        '='
      );
      const decodedPayload = JSON.parse(window.atob(paddedPayload));
      // Security: Safe logging without exposing sensitive token data
      console.debug('[session] token parsed successfully');
      if (!decodedPayload?.exp) {
        console.debug('[session] token missing expiry claim');
        return null;
      }
      const expiryMs = Number(decodedPayload.exp) * 1000;
      console.debug('[session] token expiry computed');
      return expiryMs;
    } catch (error) {
      console.debug('[session] token parsing failed');
      return null;
    }
  };

  const formatRemainingTime = (remainingSeconds: number): string => {
    const safeSeconds = Math.max(remainingSeconds, 0);
    const minutes = Math.floor(safeSeconds / 60);
    const seconds = safeSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  };

  const refreshTokenManually = async () => {
    setIsRefreshing(true);
    try {
      const refreshed = await refreshAccessToken();
      if (!refreshed) {
        logoutToLogin();
        return;
      }
      const updatedToken = localStorage.getItem('token');
      if (updatedToken) {
        const nextExpiry = parseTokenExpiry(updatedToken);
        setSessionEndsAt(nextExpiry);
      }
      setShowExpiryDialog(false);
    } catch (error) {
      logoutToLogin();
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    // Security: Safe logging without exposing token information
    console.debug('[session] authentication state check completed');
    if (!token) {
      setSessionEndsAt(null);
      setShowExpiryDialog(false);
      return;
    }
    const expiry = parseTokenExpiry(token);
    // Security: Safe logging without exposing session timing details
    console.debug('[session] session end time computed');
    setSessionEndsAt(expiry);
  }, [userLogged]);

  useEffect(() => {
    if (!sessionEndsAt) {
      return;
    }

    if (isPublicAuthFlowPath(location.pathname)) {
      return;
    }

    const now = Date.now();
    const warningDelay = Math.max(sessionEndsAt - now - 300000, 0);
    const logoutDelay = Math.max(sessionEndsAt - now, 0);

    const warningTimer = window.setTimeout(() => {
      setShowExpiryDialog(true);
    }, warningDelay);

    const logoutTimer = window.setTimeout(() => {
      logoutToLogin();
    }, logoutDelay);

    return () => {
      window.clearTimeout(warningTimer);
      window.clearTimeout(logoutTimer);
    };
  }, [sessionEndsAt, location.pathname]);

  useEffect(() => {
    if (!sessionEndsAt) {
      setOverallSessionSecondsRemaining(0);
      return;
    }

    const updateOverallRemaining = () => {
      const remaining = Math.max(Math.ceil((sessionEndsAt - Date.now()) / 1000), 0);
      setOverallSessionSecondsRemaining(remaining);
    };

    updateOverallRemaining();
    const intervalId = window.setInterval(updateOverallRemaining, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [sessionEndsAt]);

  useEffect(() => {
    if (!showExpiryDialog || !sessionEndsAt) {
      setSecondsRemaining(0);
      return;
    }

    const updateRemaining = () => {
      const remaining = Math.max(Math.ceil((sessionEndsAt - Date.now()) / 1000), 0);
      setSecondsRemaining(remaining);
    };

    updateRemaining();
    const intervalId = window.setInterval(updateRemaining, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [showExpiryDialog, sessionEndsAt]);

  const crossTabLogout = useCallback((shouldClearStorage: boolean = false) => {
    if (shouldClearStorage) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
    }
    CheckAuth.setIsUnauthorized();
    setShowExpiryDialog(false);
    setSessionEndsAt(null);

    // Set a flag so Landing.tsx knows we were kicked out and shouldn't auto-login
    sessionStorage.setItem('kicked_out_crosstab', 'true');
    navigate('/login');
  }, [navigate]);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      // 1. Detect explicit logouts
      if (e.key === 'token' && e.newValue === null) {
        crossTabLogout(false);
      }
      // 2. Detect ANY login
      if (e.key === 'login_timestamp' && e.newValue !== e.oldValue) {
        crossTabLogout(false);
      }
      // 3. Detect if another tab was opened and claimed the session
      if (e.key === 'active_tab_id' && e.newValue && e.newValue !== TAB_ID) {
        crossTabLogout(false);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [crossTabLogout]);



  //   useEffect(() => {
  //     setSelfRatingLink('0');
  // })

  return (
    <ThemeProvider theme={THEME}>
      <div className="App"  >
        {/* <BackgroundPattern /> */}
        <Header
          className="App-header"
          sessionCountdown={sessionEndsAt ? formatRemainingTime(overallSessionSecondsRemaining) : undefined}
        >
        </Header>
        <Routes>
          <Route path='/' element={userLogged && localStorage.getItem('token') ? <Home /> : <Landing />}></Route>
          <Route path='/admin' element={
            <UserAdminRoute> <Admin checkUnAuth={CheckAuth.isUnauthorized} /> </UserAdminRoute>
          }></Route>
          <Route path='/login' element={<Landing />}></Route>
          <Route path='eligibilityQuestioner' element={<EligibilityQuestioner />}></Route>
          <Route path='eligibilityResults' element={<EligibilityResults />}></Route>
          <Route path='signUp' element={<SignUp />}></Route>
          <Route path='resetPassword' element={<ResetPassword />}></Route>
          <Route path='setPassword' element={<ForgotPassword />}></Route>

          <Route path='/detailed/sidbiReference'
            element={
              <PrivateRoute>
                <SidbiReference checkUnAuth={CheckAuth.isUnauthorized} />
              </PrivateRoute>
            }>
          </Route>

          <Route path='home'
            element={
              <PrivateRoute>
                <Home checkUnAuth={CheckAuth.isUnauthorized} />
              </PrivateRoute>
            }>
          </Route>

          <Route path='profile'
            element={
              <PrivateRoute>
                <ProfileComponent />
              </PrivateRoute>
            }>
          </Route>

          <Route path='workflow' element={
            <UserRoute>
              <Workflow checkUnAuth={CheckAuth.isUnauthorized} />
            </UserRoute>
          }>
          </Route>

          <Route path='changePassword'
            element={
              <PrivateRoute>
                <ChangePassword checkUnAuth={CheckAuth.isUnauthorized} />
              </PrivateRoute>
            }>
          </Route>

          <Route path='preliminary'
            element={
              <PrivateRoute>
                <FundOverview checkUnAuth={CheckAuth.isUnauthorized} />
              </PrivateRoute>
            }>
          </Route>

          <Route path='preliminary/:id'
            element={
              <PrivateRoute>
                <FundOverview checkUnAuth={CheckAuth.isUnauthorized} />
              </PrivateRoute>
            }>

            <Route path='fund'
              element={
                <PrivateRoute>
                  <Fund checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='profile'
              element={
                <PrivateRoute>
                  <ProfileNew checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='selfRating'
              element={
                <PrivateRoute>
                  <SelfRating checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='declaration'
              element={
                <PrivateRoute>
                  <Declaration checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='preview'
              element={
                <PrivateRoute>
                  <Preview checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

          </Route>

          <Route path='Detailed' element={<DetailedApplicationComponent />}></Route>

          <Route path='Detailed/:id'
            element={
              <PrivateRoute>
                <DetailedApplicationComponent />
              </PrivateRoute>
            }>

            <Route path='detailed2A'
              element={
                <PrivateRoute>
                  <DetailedApplication2A checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2B'
              element={
                <PrivateRoute>
                  <DetailedApplication2B isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2C'
              element={
                <PrivateRoute>
                  <DetailedApplication2C isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2D'
              element={
                <PrivateRoute>
                  <DetailedApplication2D isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2E'
              element={
                <PrivateRoute>
                  <DetailedApplication2E isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2F'
              element={
                <PrivateRoute>
                  <DetailedApplication2F isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2G'
              element={
                <PrivateRoute>
                  <DetailedApplication2G isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2H'
              element={
                <PrivateRoute>
                  <DetailedApplication2H isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2I'
              element={
                <PrivateRoute>
                  <DetailedApplication2I isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2J'
              element={
                <PrivateRoute>
                  <DetailedApplication2J isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='detailed2K'
              element={
                <PrivateRoute>
                  <DetailedApplication2K isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='InvestmentThemeOfFund'
              element={
                <PrivateRoute>
                  <InvestmentThemeOfFund isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='EngagementAndRole'
              element={
                <PrivateRoute>
                  <EngagementAndRole isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='SidbiReference'
              element={
                <PrivateRoute>
                  <SidbiReference checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>

            <Route path='carryDistribution'
              element={
                <PrivateRoute>
                  <CarryDistribution isCrtStateToUpdate={checkIsCorrectStateToUpdate} checkUnAuth={CheckAuth.isUnauthorized} />
                </PrivateRoute>
              }>
            </Route>
          </Route>
        </Routes>
        <Dialog
          open={showExpiryDialog}
          onClose={() => { }} // Prevent closing by clicking outside
          disableEscapeKeyDown // Prevent ESC key from closing
          maxWidth="sm"
          fullWidth
          BackdropProps={{
            sx: {
              backdropFilter: 'blur(8px)',
              backgroundColor: 'rgba(15, 23, 42, 0.75)',
            }
          }}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.35)',
              overflow: 'hidden',
            }
          }}
        >
          <DialogTitle sx={{
            backgroundColor: '#ff6b35',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 2,
            px: 3,
            fontSize: '18px',
            fontWeight: 700
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'white',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              color: '#ff6b35',
              fontSize: '16px'
            }}>
              ⏰
            </Box>
            Session Expiring Soon
          </DialogTitle>
          <DialogContent sx={{ py: 3, px: 3, textAlign: 'left' }}>
            <Typography variant="body1" sx={{ mb: 1, mt: 2, color: '#1e293b', fontWeight: 700, fontSize: '16px' }}>
              Your session will expire in less than 5 minutes.
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, color: '#64748b', fontSize: '14px', lineHeight: 1.5 }}>
              You might lose unsaved information if you don't refresh your session.
            </Typography>
            <Box sx={{
              color: '#ff6b35',
              fontWeight: 800,
              fontSize: '24px',
              textAlign: 'center',
              py: 2.5,
              px: 3,
              backgroundColor: '#fff3e0',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1.5,
              width: '100%',
              boxSizing: 'border-box',
              animation: 'beat 1s infinite alternate ease-in-out',
              '@keyframes beat': {
                '0%': { transform: 'scale(1)' },
                '100%': { transform: 'scale(1.02)' }
              }
            }}>
              ⏱️ {secondsRemaining}s remaining
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3, pt: 0, gap: 1.5, justifyContent: 'flex-end' }}>
            <Button
              onClick={logoutToLogin}
              variant="outlined"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                color: '#64748b',
                borderColor: '#cbd5e1',
                px: 3,
                py: 1,
                '&:hover': {
                  backgroundColor: '#f8fafc',
                  borderColor: '#94a3b8',
                  color: '#1e293b'
                }
              }}
            >
              Logout
            </Button>
            <Button
              onClick={refreshTokenManually}
              disabled={isRefreshing}
              variant="contained"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                px: 3,
                py: 1,
                backgroundColor: '#ff6b35',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#e55a1f',
                  boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
                },
                '&:disabled': {
                  backgroundColor: '#cbd5e1',
                  color: '#94a3b8'
                }
              }}
            >
              {isRefreshing ? '🔄 Refreshing...' : '✓ Refresh Session'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}

export default App;
